import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

import CheckClaimRow from "./check_claim_row";

const CheckClaimTable = props => {
   return (
      <Table celled>
         <Table.Header>
            <Table.Row>
               <Table.HeaderCell>Claim ID</Table.HeaderCell>
               <Table.HeaderCell>Case ID</Table.HeaderCell>
               <Table.HeaderCell>Claim Type</Table.HeaderCell>
               <Table.HeaderCell>Created At</Table.HeaderCell>
            </Table.Row>
         </Table.Header>
         <Table.Body>
            {props.claims.length > 0 ? (
               _.map(props.claims, claim => {
                  return <CheckClaimRow claim={claim} key={claim.id} />;
               })
            ) : (
               <Table.Row>
                  <Table.Cell>No Claims To Display</Table.Cell>
               </Table.Row>
            )}
         </Table.Body>
      </Table>
   );
};

export default CheckClaimTable;
